import React, { useState } from "react";
import { ActionsMenu, ActionsMenuTrigger, MenuItem } from "ui/actions-menu";
import { CampaignFolderDTO } from "generated/schemas";
import { useFolderActions } from "containers/admin/clients/campaign/campaign-creative-page/hooks/use-folder-actions";

interface FolderActionMenuProps {
  folder: CampaignFolderDTO;
}

const FolderActionMenu: React.FC<FolderActionMenuProps> = ({ folder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { actions, modalMarkup } = useFolderActions(folder);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  return (
    <>
      <ActionsMenu
        itemName={folder.name || "Folder menu"}
        open={isOpen}
        onOpen={handleMenuOpen}
        onClose={handleMenuClose}
        offsetLeft={0}
        offsetTop={12}
        trigger={<ActionsMenuTrigger size="large" />}>
        {actions.map((action) => (
          <MenuItem
            key={action.label}
            icon={action.icon}
            label={action.label}
            onClick={() => {
              action.onClick();
              setIsOpen(false);
            }}
          />
        ))}
      </ActionsMenu>
      {modalMarkup}
    </>
  );
};

export default FolderActionMenu;
